import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";

export const detailsConfig: PageConfig[] = [
  {
    name: "details",
    title: "Initiative Details",
    questions: [
      {
        type: "text",
        name: "initiativeName",
        title: "Name of Initiative",
        placeHolder: "Te ingoa o te kaupapa",
        isRequired: true,
      },
      {
        type: "comment",
        name: "initiativeDescription",
        title: "Description of the kaupapa",
        placeHolder: "Whakamārama mai i te kaupapa",
        isRequired: true,
      },
    ],
  },
  {
    name: "purpose",
    title: "Initiative Purpose",
    questions: [
      {
        type: "comment",
        name: "initiativePurpose",
        title: "What is the ultimate goal or purpose of your initiative?",
        placeHolder: "He aha te whāinga o te kaupapa?",
        isRequired: true,
      },
      {
        type: "comment",
        name: "initiativeAlignment",
        title:
          "How does this initiative align with Rangitāne strategic priorities, values, or objectives?",
        placeHolder:
          "Ka pēhea tēnei kaupapa e hāngai ki te rautaki o te Rūnanga?",
        isRequired: true,
      },
      {
        type: "comment",
        name: "initiativeNeed",
        title: "How do you know there is a need for this initiative?",
        placeHolder: "Ka pēhea koe e mōhio he matea tō tēnei kaupapa?",
        isRequired: true,
      },
    ],
  },
  {
    name: "impact",
    title: "Initiative Impact",
    description: "Your initiative does not need to cover all five areas",
    questions: [
      {
        type: "comment",
        name: "initiativeImpactReo",
        title: `
          How will this initiative directly impact promotion of te reo Māori for
          Rangitāne whānau?
        `,
        placeHolder:
          "Ka pēhea tēnei kaupapa e whakatairangatia te reo o Rangitāne?",
      },
      {
        type: "comment",
        name: "initiativeImpactTikanga",
        title: `
          How will this initiative directly impact development of tikanga for
          Rangitāne whānau?
        `,
        placeHolder:
          "Ka pēhea tēnei kaupapa e whakawhanaketia te tikanga o Rangitāne?",
      },
      {
        type: "comment",
        name: "initiativeImpactMatauranga",
        title: `
          How will this initiative directly impact sharing and development of
          mātauranga for Rangitāne whānau?
        `,
        placeHolder:
          "Ka pēhea tēnei kaupapa e tohaina, e whakawhanaketia te mātauranga o Rangitāne?",
      },
      {
        type: "comment",
        name: "initiativeImpactCulturalRevitalisation",
        title: `
          How will this initiative directly impact cultural revitalisation for
          Rangitāne whānau?
        `,
        placeHolder:
          "Ka pēhea tēnei kaupapa e whakarauorahia te ahurea o Rangitāne?",
      },
      {
        type: "comment",
        name: "initiativeImpactWhanauWellbeing",
        title: `
          How will this initiative directly impact the wellbeing of Rangitāne
          whānau?
        `,
        placeHolder:
          "Ka pēhea tēnei kaupapa e pikia te oranga o ngā whānau o Rangitāne?",
      },
    ],
  },
];
